import apiClient from '@/api/index'

export default {
  index (newsId, params) {
    return apiClient.get(`/news/${newsId}/media`, { params })
  },
  store (newsId, formData) {
    return apiClient.post(`/news/${newsId}/media`, formData)
  },
  show (newsId, mediaId, params) {
    return apiClient.get(`/news/${newsId}/media/${mediaId}`, { params })
  },
  update (newsId, mediaId, formData) {
    formData.append('_method', 'PUT')
    return apiClient.post(`/news/${newsId}/media/${mediaId}`, formData)
  },
  destroy (newsId, mediaId) {
    return apiClient.delete(`/news/${newsId}/media/${mediaId}`)
  }
}
